import { User, UserManager, UserManagerSettings, WebStorageStateStore } from 'oidc-client';
export { User };

export class AuthService {
    public static $inject = ['$location'];
    userManager: UserManager;
    clientRoot: string;
    constructor(public $location: any) {       

        this.clientRoot = this.getCurrentBaseUrl();
        const settings = {
            authority: this.clientRoot,
            client_id: "assetworx.web",
            client_secret: "901564A5-E7FE-42CB-B10D-61EF6A8F3654",
            redirect_uri: this.clientRoot + 'assets/signin-callback.html',
            silent_redirect_uri: this.clientRoot + 'assets/silent-callback.html',
            automaticSilentRenew: true,
            post_logout_redirect_uri: this.clientRoot + '#!loggedout',
            userStore: new WebStorageStateStore({ store: localStorage }),
            response_type: 'code',
            response_mode: 'query',
            scope: 'openid profile email',
            loadUserInfo: false
        };
        console.log("*****************Auth settings.!!!!");
        this.userManager = new UserManager(settings);
    }

    public setAuthenticationServer(server: string, clientId: string, clientSecret: string, useLocalStorage: boolean) {
        if (server === null || server === '' || server == undefined) {
            var protocol = this.$location.protocol();
            var host = this.$location.host();
            var port = this.$location.port();
            var combined = protocol + '://' + host + ':' + port;
            server = combined;
        }
        let myStorage = useLocalStorage ? localStorage : sessionStorage;
        const settings = {
            authority: server,
            client_id: clientId,
            //client_secret: "901564A5-E7FE-42CB-B10D-61EF6A8F3654",
            client_secret: clientSecret,
            redirect_uri: this.clientRoot + 'assets/signin-callback.html',
            silent_redirect_uri: this.clientRoot + 'assets/silent-callback.html',
            automaticSilentRenew: true,
            post_logout_redirect_uri: this.clientRoot + '#!loggedout',
            userStore: new WebStorageStateStore({ store: myStorage }),
            response_type: 'code',
            response_mode: 'query',
            scope: 'openid profile email',
            loadUserInfo: false
        };
        console.log("*****************Auth settings RESET.!!!!");
        this.userManager = new UserManager(settings);
    }

    private getCurrentBaseUrl() {
        var protocol = this.$location.protocol();
        var host = this.$location.host();
        var port = this.$location.port();
        var combined = protocol + '://' + host + ':' + port + '/';
        return combined;
    }

    public getUser(): Promise<User> {
        return this.userManager.getUser();
    }

    public login(): Promise<void> {
        return this.userManager.signinRedirect();
    }

    public renewToken(): Promise<User> {
        return this.userManager.signinSilent();
    }

    public logout(): Promise<void> {
        return this.userManager.signoutRedirect();
    }
}
